import Cookies from 'js-cookie';

interface AuthStorageType {
  setItem: (key: string, value: string) => void;
  getItem: (key: string) => string | undefined;
  removeItem: (key: string) => void;
  clear: () => void;
}

const CognitoTokenKeys = ['idToken', 'accessToken', 'refreshToken', 'LastAuthUser'];

/**
 * This is used to set a specific item in storage
 */
function setItem(key: string, value: string) {
  const keyName = key.split('.').pop();
  CognitoTokenKeys.forEach((CognitoTokenKeyName) => {
    if (keyName === CognitoTokenKeyName) {
      Cookies.set(keyName, value, {
        path: '/',
        expires: 30,
        sameSite: 'strict',
        secure: true,
      });
    }
  });
}

/**
 * This is used to get a specific key from storage
 */
function getItem(key: string) {
  const keyName = key.split('.').pop() || '';
  return Cookies.get(keyName);
}

/**
 * This is used to remove an item from storage
 */
function removeItem(key: string) {
  const keyName = key.split('.').pop() || '';
  return Cookies.remove(keyName, {
    path: '/',
  });
}

/**
 * This is used to clear the storage
 */
function clear() {
  CognitoTokenKeys.forEach((CognitoTokenKeyName) => {
    Cookies.remove(CognitoTokenKeyName);
  });
}

const AuthStorage: AuthStorageType = {
  setItem,
  getItem,
  removeItem,
  clear,
};

export const AwsConfigAuth = {
  region: process.env.REACT_APP_AUTH_REGION,
  userPoolId: process.env.REACT_APP_AUTH_USER_POOL_ID,
  userPoolWebClientId: process.env.REACT_APP_AUTH_USER_POOL_WEB_CLIENT_ID,
  storage: AuthStorage,
  authenticationFlowType: 'CUSTOM_AUTH',
} as const;
